module.exports = __webpack_public_path__ + "static/img/rank_116.eff6c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_116.png
// module id = na9U
// module chunks = 1